import { createAction } from '@reduxjs/toolkit'
import type { ResetEventAction } from '../types/index.js'

export const resetAction = createAction<ResetEventAction | undefined>('OP_RESET')
